export default __webpack_public_path__ + "static/media/background_grid_moonchicken.c3f515b4.png";